import React from 'react';
import { Link } from 'react-router-dom';
import './Category.scss';
import  Messages from '../../components/shared/Messages.jsx';
import Logo from '../../components/shared/Logo.jsx';
import { useAppData } from '../../context/AppDataContext.jsx';
import SkeletonCard from '../../components/SkeletonCard.jsx';

// Reusable DatasetCard component
const DatasetCard = ({ dataset, outlooks }) => {
  console.log('Outlooks in DatasetCard:', outlooks);
  const { icon, to, id } = dataset;
  const outlook = Array.isArray(outlooks) && id ? outlooks.find(o => o.id === id) : null;
  const title = outlook ? outlook.title : dataset.title;
  const description = outlook ? outlook.shortDescription : dataset.description;
  return (
    <Link to={to} className="dataset-card">
      <div className="dataset-card-header">
        <div className="dataset-icon">
          {/* If the icon is a string emoji, display as text; if it's a path, display as image */}
          {typeof icon === 'string' && (icon.endsWith('.png') || icon.endsWith('.jpg')) ? (
            <img
              src={`/${icon.replace(/^public\//, '')}`}
              alt={title}
            />
          ) : (
            <span>{icon}</span>
          )}
        </div>
        <h3 className="dataset-title">{title}</h3>
        <div className="dataset-arrow">→</div>
      </div>
      <p className="dataset-description">{description}</p>
    </Link>
  );
};

const Category = () => {
  const { outlooks, loading } = useAppData ? useAppData() : { outlooks: [], loading: false };

  const globalOutlooks = [
    {
      to: '/g/global-crude/overview',
      id: 'global-crude',
      icon: '🛢️'
    },
    {
      to: '/g/global-fuels/overview',
      id: 'global-fuels',
      icon: '⛽'
    },
    {
      to: '/g/global-refining/overview',
      id: 'global-refining',
      icon: '🏭'
    },
    {
      to: '/g/global-petrochemical-feedstocks/overview',
      id: 'global-petrochemical-feedstocks',
      icon: '🧪'
    },
    {
      to: '/g/global-renewable-fuels/overview',
      id: 'global-renewable-fuels',
      icon: '🌱'
    },
    {
      to: '/recent-publications',
      id: 'recent-publications',
      title: 'Recent Publications',
      description: 'All publications available to your account.',
      icon: '📰'
    }
  ];

  const regionalOutlooks = [
    {
      to: '/r/regional-africa/overview',
      id: 'regional-africa',
      icon: 'static/globes/Middle East Africa.png'
    },
    {
      to: '/r/regional-north-america/overview',
      id: 'regional-north-america',
      icon: 'static/globes/North America.png'
    },
    {
      to: '/r/regional-latin-america/overview',
      id: 'regional-latin-america',
      icon: 'static/globes/Latin America.png'
    },
    {
      to: '/r/regional-europe/overview',
      id: 'regional-europe',
      icon: 'static/globes/Middle East Africa.png'
    },
    {
      to: '/r/regional-middle-east/overview',
      id: 'regional-middle-east',
      icon: 'static/globes/Middle East Africa.png'
    },
    {
      to: '/r/regional-asia/overview',
      id: 'regional-asia',
      icon: 'static/globes/Asia.png'
    },
    {
      to: '/r/regional-china/overview',
      id: 'regional-china',
      icon: 'static/globes/China.png'
    },
    {
      to: '/r/regional-cis/overview',
      id: 'regional-cis',
      icon: 'static/globes/Asia.png'
    }
  ];

return (
  <div className="category-container">
    {/* <div className="category-header">
      <Logo variant="dark" />
      <p className="category-subtitle">Energy Market Analysis and Forecasting for Decisionmakers</p>
    </div> */}
    <Messages />
    <div className="category-sections">
      
      {/* Global Outlooks Section */}
      <div className="category-section">
        <h2 className="section-title">
        Global Outlooks
        </h2>
        <p className="section-description">
          {/* welcome message for new users */}
          
        </p>
        <div className="dataset-grid grid-3-columns">
          {loading || !outlooks
            ? globalOutlooks.map((_, i) => <SkeletonCard key={i} />)
            : globalOutlooks.map((dataset, index) => (
                <DatasetCard key={index} dataset={dataset} outlooks={outlooks} />
              ))}
        </div>
        <h2 className="section-title">
          Regional Watches
        </h2>
        <p className="section-description">
          Integrated regional analysis across crude and refined products markets
        </p>
        <div className="dataset-grid grid-4-columns">
          {loading || !outlooks
            ? regionalOutlooks.map((_, i) => <SkeletonCard key={i} />)
            : regionalOutlooks.map((dataset, index) => (
                <DatasetCard key={index} dataset={dataset} outlooks={outlooks} />
              ))}
        </div>
      </div>

    </div>
  </div>
);
};

export default Category;
